module.exports = __webpack_public_path__ + "8bb1e4e295931bca15786a3098e84985.pdf";